import { FlowType, TourStep } from 'src/frontend/constants/GettingStartedFlows';
import { proxy, subscribe } from 'valtio';

import { LocalStorageService } from 'services/LocalStorageService';

const STORAGE_KEY = 'getting-started-tour';

type TourState = {
    activeTour: FlowType | null;
    activeTourStep: TourStep | null;
    popoverIsShown: boolean;
    preTourComponentInstanceIds: string[];
    preTourConnectionIds: string[];
    tourComponentInstanceIds: string[];
    tourConnectionIds: string[];
    tourTargetConnectionId: string | null;
    completedTours: FlowType[];
};

const storedState = LocalStorageService.get<TourState>(STORAGE_KEY);

const gettingStartedTourState = proxy<TourState>({
    activeTour: storedState?.activeTour ?? null,
    activeTourStep: storedState?.activeTourStep ?? null,
    popoverIsShown: false,
    preTourComponentInstanceIds: storedState?.preTourComponentInstanceIds ?? [],
    preTourConnectionIds: storedState?.preTourConnectionIds ?? [],
    tourComponentInstanceIds: storedState?.tourComponentInstanceIds ?? [],
    tourConnectionIds: storedState?.tourConnectionIds ?? [],
    tourTargetConnectionId: storedState?.tourTargetConnectionId ?? null,
    completedTours: storedState?.completedTours ?? [],
});

subscribe(gettingStartedTourState, (changes) => {
    if (changes.some(([, path]) => path[0] === 'activeTour')) {
        gettingStartedTourState.activeTourStep = null;
        gettingStartedTourState.popoverIsShown = false;

        // Only drop the tracked elements once nothing is running: a tour that is
        // starting has already recorded what the diagram held before it began.
        if (!gettingStartedTourState.activeTour) {
            gettingStartedTourState.preTourComponentInstanceIds = [];
            gettingStartedTourState.preTourConnectionIds = [];
            gettingStartedTourState.tourComponentInstanceIds = [];
            gettingStartedTourState.tourConnectionIds = [];
            gettingStartedTourState.tourTargetConnectionId = null;
        }
    }

    if (
        gettingStartedTourState.activeTour ||
        gettingStartedTourState.activeTourStep ||
        gettingStartedTourState.completedTours.length ||
        gettingStartedTourState.tourComponentInstanceIds.length ||
        gettingStartedTourState.tourConnectionIds.length
    ) {
        LocalStorageService.store(STORAGE_KEY, {
            activeTour: gettingStartedTourState.activeTour,
            activeTourStep: gettingStartedTourState.activeTourStep,
            completedTours: gettingStartedTourState.completedTours,
            preTourComponentInstanceIds: gettingStartedTourState.preTourComponentInstanceIds,
            preTourConnectionIds: gettingStartedTourState.preTourConnectionIds,
            tourComponentInstanceIds: gettingStartedTourState.tourComponentInstanceIds,
            tourConnectionIds: gettingStartedTourState.tourConnectionIds,
            tourTargetConnectionId: gettingStartedTourState.tourTargetConnectionId,
        });
        return;
    }

    LocalStorageService.clear(STORAGE_KEY);
});

export { gettingStartedTourState };
